import type { TableView } from "owa-mail-list-store";
import virtualizedMailGroupHeadersStore from "../store/store";
import toggleVirtualizedGroupHeaderCollapse from "./toggleVirtualizedGroupHeaderCollapse";

/**
 * Expands the collapsed group header that contains the row, if any, so the row is rendered.
 * Other groups keep their collapse state.
 */
export default function expandGroupHeaderContainingRow(rowKey: string, tableView: TableView): void {
    for (const [headerName, header] of virtualizedMailGroupHeadersStore().virtualizedGroupHeaders) {
        if (header.isCollapsed && header.rowKeys.includes(rowKey)) {
            toggleVirtualizedGroupHeaderCollapse(headerName, tableView);
            return;
        }
    }
}
